
Vue.component('social-settings-links', {
    template: `
        <div class="social-settings-links">
            <ul class="nav nav-pills" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(c_class, channel) in channels">
                        <a class="nav-link" :class="{ active : active == channel }" :id="channel + '-tab'" data-toggle="tab" :href="'#' + channel" role="tab" aria-controls="facebook" aria-selected="true">
                            <i :class="c_class"></i>&nbsp;
                            <div v-if="enabledChannels.indexOf(channel) > -1" class="bg-light rounded px-2 py-1">
                                <i class="fas fa-check text-success" ></i>
                            </div>
                        </a>
                    </li>
            </ul>
        </div>
    `,

    data() {

        return {
            channels: {

                facebook: 'fab fa-facebook-f',
                google: 'fab fa-google'

            },

            enabledChannels: [],
            active: 'google'

        }

    },

    mounted() {

        axios.get('/api/social-settings/' + Spark.state.currentTeam.id)
        .then(response => {
            this.enabledChannels = response.data;
        });

        this.$eventHub.$on('channelEnabled',(channel)=>{

            if(this.enabledChannels.indexOf(channel) == -1) {

                this.enabledChannels.push(channel);

            }
        });

        this.$eventHub.$on('channelDisabled',(channel)=>{

            let index = this.enabledChannels.indexOf(channel);

            if(index > -1) {

                this.enabledChannels.splice(index,1);

            }
        });
    }
});

Vue.component('facebook-settings', {

	props: ['fb_id', 'facebook_page', 'team_id'],

	// @TODO: Add confirmation modal for deleting page
    template: `<slot></slot>`,

	data() {

		return {

			fbSignInParams: {
	        	scope: 'email,public_profile,manage_pages,publish_pages,instagram_basic,instagram_manage_comments,instagram_manage_insights',
	        	return_scopes: true
	      	},

            // The selected page access token
            selectedPageIndex: 0,
            facebookPage: null,
            show_fb_login: true,
            pages: [],
            userName: ''
		}

	},

	mounted() {

        this.facebookPage = this.facebook_page;

        var instance = this;

		window.fbAsyncInit = function() {
            FB.init({
                appId      : instance.fb_id,
                cookie     : true,
                xfbml      : true,
                version    : 'v9.0'
            });

            // FB.AppEvents.logPageView();

            FB.getLoginStatus(function(response) {
                if (response.status == 'connected') {
                    instance.onSignInSuccess();
                }
            });


        };
        (function (doc) {
            var js;
            var id = 'facebook-jssdk';
            var ref = doc.getElementsByTagName('script')[0];
            if (doc.getElementById(id)) {
                return;
            }
            js = doc.createElement('script');
            js.id = id;
            js.async = true;
            js.src = "//connect.facebook.net/en_US/all.js";
            ref.parentNode.insertBefore(js, ref);
        }(document));
	},

	methods: {

		onSignInSuccess(response) {

            this.show_fb_login = false;
            document.getElementById('select-facebook-pages').classList.add('active');
            this.getUserPages();
		},

		onSignInError(error) {

		},

        async savePage() {

            if (this.selectedPageIndex == -1) {
                return
            }

            let page = this.pages[this.selectedPageIndex]
            // const params = {
            //     fields: 'instagram_business_account'
            // }
            // const instagramPageId = await FB.api(page.id, params, function (response) {
            //     console.log(response);
            // });
            // console.log(instagramPageId);
            // return;

            const data = {
                name: page.name,
                id: page.id,
                accessToken: page.access_token
            }

            var instance = this

            axios.post('/api/settings/' + this.team_id +  "/facebook", data).then(function (response) {

                // Success
                var data = response.data

                if (data.status == 'success') {

                    instance.facebookPage = data.facebook_page
                    swal("Congrats!", data.message, "success")

                }

            },function (response) {
                // Error
                console.log(response.data)
            });

        },

        deletePage() {

            let instance = this

			axios.delete(`/api/settings/${this.team_id}/facebook/${this.facebookPage.id}`).then(function (response) {

                var data = response.data;

                if (data == 'success') {

                    instance.facebookPage = null;

                }

            }, function(response) {});


        },

        handleChange(e) {

            if(e.target.options.selectedIndex > -1) {
                this.selectedPageIndex = e.target.options.selectedIndex
            }

        },
        getUserPages() {

            var instance = this;

            FB.api('/me', function(response) {
                instance.userName = response.name;
            });

            var getPages = function(response) {

                instance.pages = instance.pages.concat(response.data)

                if (typeof response.paging != 'undefined' && response.paging.next) {
                    FB.api(response.paging.next, getPages);
                }

            }

            FB.api('/me/accounts', getPages);
        }

	}

});